const name = "@prismicio/adapter-nuxt2";
export {
  name
};
//# sourceMappingURL=package.json.js.map
